import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import styles from 'assets/css/Hypo.module.css';
import ListHypo from "./ListHypo";
import {useRef} from "react";

const CustomizedDialog = styled(Dialog)`
  & .MuiDialog-paper {
    width: 100%;
    margin: 16px;
    background: #ffffff;
    min-height: 350px;
    border: 1px solid #ffffff;
    box-shadow: 8px 8px 20px rgba(172, 172, 172, 0.5), -8px -8px 20px #ffffff;
    border-radius: 16px;
    padding: 0px;
  }

  & .MuiBackdrop-root {
    background-color: rgba(216, 216, 216, 0.3);
    backdrop-filter: blur(6.7957px);
  }

  & .MuiDialogContent-root {
    padding: 0;
    background-color: #ffffff;
  }
`;

const HypoListModal = (props) => {
  const { open, setOpen, daysAgo,patientId } = props;
  const topModalRef = useRef();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <CustomizedDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle className={styles.dialogContainer} id="alert-dialog-title">
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 20,
            top: 34,
            color: '#707070',
            width: '3px',
          }}
        >
          <CloseIcon sx={{ width: '1rem', height: '1rem' }} />
        </IconButton>
        <p className={styles.modalTitle}>رویداد های هایپوگلیسمی:</p>
      </DialogTitle>
      <DialogContent>
        <Grid ref={topModalRef} container className={styles.descriptionContainer}>
          <Grid item xs={12} display="flex" justifyContent="center" dir="ltr">
            <span className={styles.redText}>
              تحلیل ها بر اساس {daysAgo} روز گذشته
            </span>
          </Grid>
          <Grid item xs={12} mt="7px" dir="">
            <p className={styles.purpleText}>
              برای مشاهده بیشتر موارد هایپوگلیسمی، لطفاً بازه <br /> زمانی گزارش
              را تغییر دهید.
            </p>
          </Grid>
        </Grid>
        <ListHypo daysAgo={daysAgo} patientId={patientId} topModalRef={topModalRef}/>
      </DialogContent>
    </CustomizedDialog>
  );
};
export default HypoListModal;
